'use strict';

// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************

'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BASE_FONT_FAMILY = exports.BASE_FONT_FAMILY = 'Avenir Next';
var BASE_FONT_REGULAR = exports.BASE_FONT_REGULAR = 'Avenir Next Regular';
var BASE_FONT_BOLD = exports.BASE_FONT_BOLD = 'Avenir Next Bold';
var BASE_FONT_MEDIUM = exports.BASE_FONT_MEDIUM = 'Avenir Next Medium';
var BASE_FONT_DEMI_BOLD = exports.BASE_FONT_DEMI_BOLD = 'Avenir Next Demi';
var BASE_FONT_ITALIC = exports.BASE_FONT_ITALIC = 'Avenir Next Italic';
var CODE_FALLBACK_FONT_STACK = exports.CODE_FALLBACK_FONT_STACK = 'Consolas, Monaco, Courier New, monospace';
var CODE_FONT_FAMILY = exports.CODE_FONT_FAMILY = 'Source Code Pro';
var CODE_FONT_WEIGHT = exports.CODE_FONT_WEIGHT = '500';
var WEB_FONT_REGULAR = exports.WEB_FONT_REGULAR = 'Avenir Next W02';
var WEB_FONT_BOLD = exports.WEB_FONT_BOLD = 'Avenir Next W02';
var WEB_FONT_MEDIUM = exports.WEB_FONT_MEDIUM = 'Avenir Next W02';
var WEB_FONT_DEMI_BOLD = exports.WEB_FONT_DEMI_BOLD = 'Avenir Next W02';
var WEB_FONT_ITALIC = exports.WEB_FONT_ITALIC = 'Avenir Next W02';
var WEB_FONT_REGULAR_WEIGHT = exports.WEB_FONT_REGULAR_WEIGHT = '400';
var WEB_FONT_BOLD_WEIGHT = exports.WEB_FONT_BOLD_WEIGHT = '700';
var WEB_FONT_MEDIUM_WEIGHT = exports.WEB_FONT_MEDIUM_WEIGHT = '500';
var WEB_FONT_DEMI_BOLD_WEIGHT = exports.WEB_FONT_DEMI_BOLD_WEIGHT = '600';
var WEB_FONT_ITALIC_WEIGHT = exports.WEB_FONT_ITALIC_WEIGHT = '400';
var FALLBACK_FONT_STACK = exports.FALLBACK_FONT_STACK = 'Helvetica, Arial, sans-serif';
var HEADING_FONT_SMOOTHING = exports.HEADING_FONT_SMOOTHING = 'antialiased';
var HEADING_WEIGHT0 = exports.HEADING_WEIGHT0 = 'bold';
var HEADING_WEIGHT1 = exports.HEADING_WEIGHT1 = 'bold';
var HEADING_WEIGHT2 = exports.HEADING_WEIGHT2 = 'regular';
var HEADING_WEIGHT3 = exports.HEADING_WEIGHT3 = 'medium';
var HEADING_WEIGHT4 = exports.HEADING_WEIGHT4 = 'bold';
var HEADING_WEIGHT5 = exports.HEADING_WEIGHT5 = 'bold';
var HEADING_WEIGHT6 = exports.HEADING_WEIGHT6 = 'demibold';
var HEADING_WEIGHT7 = exports.HEADING_WEIGHT7 = 'demibold';
var HEADING_CASE6 = exports.HEADING_CASE6 = 'uppercase';
var INPUT_VERTICAL_ALIGNMENT = exports.INPUT_VERTICAL_ALIGNMENT = 'middle';
var TABLE_HEADER_FONT_WEIGHT = exports.TABLE_HEADER_FONT_WEIGHT = 'medium';
var TABLE_HEADER_VERTICAL_ALIGNMENT = exports.TABLE_HEADER_VERTICAL_ALIGNMENT = 'middle';
var TABLE_CELL_VERTICAL_ALIGNMENT = exports.TABLE_CELL_VERTICAL_ALIGNMENT = 'middle';
var TOOLTIP_HEADING_WEIGHT = exports.TOOLTIP_HEADING_WEIGHT = 'bold';
var TOOLTIP_LONGFORM_HEADING_WEIGHT = exports.TOOLTIP_LONGFORM_HEADING_WEIGHT = 'medium';
var TOOLTIP_SHADOW = exports.TOOLTIP_SHADOW = '0 3px 8px rgba(0, 0, 0, .1)';
var HOVERLAY_OPACITY = exports.HOVERLAY_OPACITY = '0.85';
var WELL_BIG_NUMBER_FONT_WEIGHT = exports.WELL_BIG_NUMBER_FONT_WEIGHT = 'regular';
var WELL_LABEL_FONT_WEIGHT = exports.WELL_LABEL_FONT_WEIGHT = 'demibold';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/HubStyleTokens/static-2.88/js/misc.js
// module id = 250
// module chunks = 0